import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_fsmncxuqwh: FaireBrandEntity = {
  token: "b_fsmncxuqwh",
  type: "brand",
  name: "Decords",
  avatarUrl:
    "https://cdn.faire.com/fastly/ce6d5f9124828043e234c48d06cf21455b05db8b4f482f04446308c8697b38f7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4bd7279a4d6267d5defbc046feb75bf234d925bca005c26bf60d09c68e406fd6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ce6d5f9124828043e234c48d06cf21455b05db8b4f482f04446308c8697b38f7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4bd7279a4d6267d5defbc046feb75bf234d925bca005c26bf60d09c68e406fd6.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 69,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Decords was founded with a clear belief: walls are not background. They are opportunities.\n\nWe design and manufacture modern wall decor that transforms empty spaces into intentional environments. Our collections include wall decals, custom vinyl graphics, interior stickers, canvas prints, and selected 3D printed decor pieces. Every product is created in-house in Europe using professional large-format printing and precision cutting technology.\n\nWhat makes Decords different is control. We do not outsource production. We design, print, cut, and finish everything ourselves. This allows us to maintain consistent quality, flexible sizing, and reliable lead times for our retail partners.\n\nOur design direction is influenced by Nordic minimalism and contemporary architecture. Clean lines, balanced composition, and neutral palettes define our core aesthetic. At the same time, we offer customization options, allowing retailers to respond to specific customer needs, room sizes, and interior styles.\n\nOur mission is simple: help retailers offer design-forward wall solutions that elevate everyday spaces while maintaining commercial viability.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.030Z",
    importedBy: "entity-db-cli",
  },
};
